import EventEmitter from "events";
import Timer from "../utils/timer";

export default class AutoRefreshToken extends EventEmitter{
    /**
     * @type {string}
     */
    _token;

    async token(){
        if(!this._token){
           await this._loadToken();
        }
        return this._token;
    }

    /**
     * @type {Timer|undefined}
     */
    _timer;

    /**
     * @type {number}
     */
    _expired;

    constructor(preloadToken = true) {
        super();
        if(preloadToken){
            this._loadToken();
        }
    }

    /**
     * @returns {Promise<string>}
     */
    async _requestToken() {
        throw new Error("未實現_requestToken()");
    }

    async _loadToken() {
        this._token = await this._requestToken();
        this.stop();
        this.start();
    }

    async start() {
        if(this._expired === undefined){
            throw new Error('未設定_expired屬性');
        }

        this._timer = new Timer(async () => {
            this._token = await this._requestToken();
            this.emit('refresh', this._token);
        }, this._expired);

        if(this._timer.state === Timer.STOP){
            this._timer.start();
        }
    }

    stop() {
        this._timer?.stop();
    }
}
